module.exports = __webpack_public_path__ + "static/nika-8be290933f1e09731342327b3a680a21.png";